var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.setup != null)?_c('div',{staticClass:"dropdown-menu-project",class:{'open' : _vm.openSendwich},attrs:{"id":"dropdown-menu-project"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"drop-down-container"},[_c('burgerNavMain')],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }